/**
 * After a release the hashed chunk names change; a tab opened before it still asks for the old
 * files and gets 404 on the first lazy page. Such a tab is reloaded once to pick up the new build.
 */

const KEY = "ishonch:reloaded-for-new-build";
const LOOP_GUARD_MS = 10_000;

/** Browsers word a failed dynamic import differently (Chrome, Safari, Firefox). */
export function isStaleBuildError(error: unknown): boolean {
  if (!(error instanceof Error)) return false;
  return /dynamically imported module|Importing a module script failed|error loading dynamically imported module|Unable to preload CSS/i.test(
    error.message,
  );
}

/** Whether a reload for a new build is allowed now (not right after the previous one). */
export function canReloadForNewBuild(): boolean {
  try {
    return Date.now() - Number(sessionStorage.getItem(KEY) ?? 0) >= LOOP_GUARD_MS;
  } catch {
    return true;
  }
}

/**
 * Reloads the page unless it was just reloaded for the same reason (then the files are really
 * missing and another reload would loop). Returns whether a reload was started.
 */
export function reloadForNewBuild(
  reload: () => void = () => {
    window.location.reload();
  },
): boolean {
  try {
    const last = Number(sessionStorage.getItem(KEY) ?? 0);
    if (Date.now() - last < LOOP_GUARD_MS) return false;
    sessionStorage.setItem(KEY, String(Date.now()));
  } catch {
    // storage blocked: still try once
  }
  reload();
  return true;
}
